export const RADIO_BUTTON_CLASSIC = 'classic'
export const RADIO_BUTTON_NEW = 'new'

export const RadioButtonThemes = [RADIO_BUTTON_CLASSIC, RADIO_BUTTON_NEW]

export type RadioButtonType = typeof RadioButtonThemes[number]
